import * as e from "react";
const a = (t) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M2 5.397A2.395 2.395 0 014.394 3h9.741a2.395 2.395 0 012.394 2.397v2.148a.909.909 0 11-1.816 0V5.397a.578.578 0 00-.578-.579H4.394a.578.578 0 00-.578.579v13.206c0 .32.259.579.578.579h9.741c.32 0 .578-.26.578-.579v-2.149a.909.909 0 111.816 0v2.15A2.395 2.395 0 0114.135 21H4.394A2.395 2.395 0 012 18.603V5.397z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M18.924 13.24l-.374.457a.907.907 0 101.406 1.151l1.839-2.25a.91.91 0 00-.061-1.218l-1.839-1.841a.907.907 0 10-1.284 1.286l.596.597H9.595a.909.909 0 000 1.818h9.33z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M2 5.397A2.395 2.395 0 014.394 3h9.741a2.395 2.395 0 012.394 2.397v2.148a.909.909 0 11-1.816 0V5.397a.578.578 0 00-.578-.579H4.394a.578.578 0 00-.578.579v13.206c0 .32.259.579.578.579h9.741c.32 0 .578-.26.578-.579v-2.149a.909.909 0 111.816 0v2.15A2.395 2.395 0 0114.135 21H4.394A2.395 2.395 0 012 18.603V5.397z",
      stroke: "#2d6ded",
      strokeWidth: 0.2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M18.924 13.24l-.374.457a.907.907 0 101.406 1.151l1.839-2.25a.91.91 0 00-.061-1.218l-1.839-1.841a.907.907 0 10-1.284 1.286l.596.597H9.595a.909.909 0 000 1.818h9.33z",
      stroke: "#2d6ded",
      strokeWidth: 0.2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
), o = a;
export {
  o as default
};
